import script from "./MyMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./MyMaterial.vue?vue&type=script&setup=true&lang=js"

import "./MyMaterial.vue?vue&type=style&index=0&id=62c6a170&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c6a170"]])

export default __exports__